const UserPrivacyChoices = () => {
    return (
        <>
            <h2>Your Privacy, Your Choice</h2>
            <p>We respect your right to control your personal data. Here is what you can do:</p>

            <h3>Leaderboard Participation</h3>
            <p>Participation in the global leaderboard is entirely optional. You may choose not to submit your score. No account creation is required to play the game.</p>

            <h3>Local Data</h3>
            <p>All gameplay data (scores, settings) is stored locally on your device. You can delete this data at any time by uninstalling the App.</p>

            <h3>Tracking & Analytics</h3>
            <p>If the App uses analytics or advertising SDKs, you may limit tracking through your device settings:</p>
            <ul>
                <li><strong>On iOS:</strong> Go to Settings → Privacy & Security → Tracking and disable "Allow Apps to Request to Track."</li>
            </ul>

            <h3>Apple Privacy Controls</h3>
            <p>You can manage app permissions (notifications, etc.) at any time through:</p>
            <p>Settings → Paper Dodge</p>

            <h3>Data Deletion Request</h3>
            <p>If you would like to request deletion of any data associated with your use of the App, please contact us at: <a href="mailto:hello@wearetla.com">hello@wearetla.com</a></p>
            <p>We will respond to your request within 30 days.</p>
        </>
    );
};

export default UserPrivacyChoices;
